import { Component, OnInit, Input } from '@angular/core';
import { WalkaroundQuestion } from '../../models/walkaround-question.model';
import { VehicleChecksAreas } from '../../../workshop/models/vehiclecheckarea.model';
import { VehicleSeverity } from '../../../workshop/models/vehicleseverity.model';
import { VehicleType } from '../../../vehicle/models/vehicle-type.model';
import { VehicleCheckService } from '../../../workshop/services/vehiclechecks.service';
import { VehicleService } from '../../../vehicle/services/vehicle.service';
import { catchError, take } from 'rxjs/operators';

@Component({
    selector: 'app-walkaround-question-form',
    templateUrl: './walkaround-question-form.component.html',
    styleUrls: ['./walkaround-question-form.component.scss'],
    standalone: false
})
export class WalkaroundQuestionFormComponent implements OnInit {

  @Input()
  question: WalkaroundQuestion;

  checkAreas: VehicleChecksAreas[] = [];
  severities: VehicleSeverity[] = [];
  vehicleTypes: VehicleType[] = [];

  constructor(
    private vehicleCheckService: VehicleCheckService,
    private vehicleService: VehicleService) { }

  ngOnInit(): void {
    this.vehicleCheckService.getAllVehicleCheckAreas()
    .pipe(catchError((e) => { alert('Check areas could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((areas: VehicleChecksAreas[]) => {
      this.checkAreas = areas;
      this.checkAreas.push({id: -1, name: 'Select a check area...'} as any);
    });

    this.vehicleCheckService.getAllVehicleSeverities()
    .pipe(catchError((e) => { alert('Severities could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((severities: VehicleSeverity[]) => {
      this.severities = severities;
      this.severities.push({id: -1, notes: 'Select a severity...'} as any);
    });

    this.vehicleService.getAllVehicleTypes()
    .pipe(catchError((e) => { alert('Vehicle types could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((types: VehicleType[]) => {
      this.vehicleTypes = types;
      this.vehicleTypes.push({id: 0, name: 'All Vehicle Types'} as any);
    });
  }

}
